import { makeStyles } from "@material-ui/styles";

const useStyles=makeStyles({
    notFound:{
        height:'100%',
        width:'100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        padding:'2rem',
        color:'white'

    },
})
export default useStyles;